import React from 'react'

const Examination_Slip = () => {
  return (
    <div>Examination_Slip</div>
  )
}

export default Examination_Slip